import React from "react";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router";
import FlatButton from "material-ui/FlatButton";
import RaisedButton from "material-ui/RaisedButton";
import { Card, CardHeader, CardText, CardActions } from "material-ui/Card";
import { Tabs, Tab } from "material-ui/Tabs";
import { getResults, getResponse, answerTextLookup } from "../reducer/response";
import FlaggedQuestionList from "../components/FlaggedQuestionList";
import InfluentialAnswersList from "../components/InfluentialAnswersList";
import Divider from "material-ui/Divider";
import AnswerEditModal from "../components/AnswerEditModal";
import {
  saveAnswerNote,
  saveAnswer,
  toggleQuestionFlagged,
  updateFisheryMetadata
} from "../actions/response";
import { questionLookup } from "../reducer/questions";
import CaveatVisualization from "../components/CaveatVisualization";
import { sortedCategories } from "../reducer/categories";
import FiltersAndSortingOptions from "../components/FiltersAndSortingOptions";
import SortIcon from "material-ui/svg-icons/content/sort";
import AppBar from "material-ui/AppBar";
import Toggle from "material-ui/Toggle";
import { toggleShortList } from "../actions/filterOptions";
import FisheryMetadataDialog from '../components/FisheryMetadataDialog';
import { makeTitle } from '../reducer';
import BackgroundSyncStatusBar from "../components/BackgroundSyncStatusBar";
import {toggleHiddenOptions} from "../actions/filterOptions";
import {fetchTranslation} from '../actions/translation';

export const buttonTextStyle = {
  textTransform: "uppercase",
  fontWeight: 500,
  fontSize: 14
};

const IncompleteSection = props => (
  <div>
    <CardHeader
      title="This section was not completed"
      subtitle={`Only ${props.completed} of the ${props.incomplete +
        props.completed} questions required to evaluate these options were answered`}
    />
    <CardText>
      {props.readOnly ? (
        <RaisedButton
          containerElement={
            <Link to={`/questionnaire/results/${props.responseID}/answers`} />
          }
          label="See all answers"
        />
      ) : (
        <RaisedButton
          containerElement={
            <Link
              to={`/questionnaire/${props.responseID}/finish/${props.section}/${
                props.nextQuestion.id
              }`}
            />
          }
          label="Finish this Section"
        />
      )}
    </CardText>
  </div>
);

class SectionResults extends React.PureComponent {
  render() {
    const { onGenerateReportClick, ...props } = this.props;

    return (
      <div>
        <AppBar
          title={<div>
            {!props.readOnly && (
              <RaisedButton
                primary={true}
                style={{marginBottom: -13, boxShadow:''}}
                label="Narrow Your Results"
                labelPosition="before"
                containerElement={
                  <Link
                    to={`/resultsReview/${props.responseID}/${
                      props.section
                    }/0`}
                  />
                }
              />
            )}
          </div>}
          style={{
            backgroundColor: "white",
            boxShadow: "none",
            color: "black",
            zIndex: 1
          }}
          titleStyle={{ color: "black", fontSize:"18px" }}
          iconStyleRight={{ color: "black" }}
          iconElementLeft={<div />}
          iconElementRight={
            <div>

              <div
              style={{
                display: "inline-flex",
                position: "relative",
                bottom: -2,
                alignItems: 'center',
                ...buttonTextStyle,
              }}
            >
              <Toggle
                label="Narrowed Options Only"
                labelPosition="left"
                style={{
                  display: "inline-block",
                  width: "auto",
                  marginRight: 10,
                  border: "1px solid lightgrey",
                  borderRadius: 6,
                  padding:5,
                  ...buttonTextStyle
                }}
                thumbStyle={{
                  backgroundColor: "rgb(0, 188, 212)"
                }}
                toggled={props.filterOptions.shortList}
                onClick={props.toggleShortList}
              />
              <Toggle
                label="Show Hidden Options"
                onClick={props.toggleHiddenOptions}
                labelPosition="left"
                toggled={props.filterOptions.displayHiddenOptions}
                disabled={props.filterOptions.shortList}
                style={{
                  display: "inline-block",
                  width: "auto",
                  marginRight: 10,
                  border: "1px solid lightgrey",
                  borderRadius: 6,
                  padding:5,
                  ...buttonTextStyle
                }}
                thumbStyle={{
                  backgroundColor: "rgb(0, 188, 212)"
                }}
              />
            </div>

              <RaisedButton
                label="Sort Options"
                labelPosition="before"
                icon={<SortIcon />}
                onClick={props.onOpenFiltersClick.bind(null, props.section)}
              />
            </div>
          }
        />

        <CardText
          style={{
            textAlign: "right",
            marginBottom: -44,
            position: "relative",
            zIndex: 1
          }}
        />
        {// TODO: Add check for write permission and change message
        props.filterOptions.shortList &&
        (!props.reviewStage || props.reviewStage < 2) ? (
          <Card style={{ maxWidth: 500, margin: "20px auto" }}>
            <CardHeader title="Create list of Top Options" />
            <CardText>
              The results for this fishery haven't yet been fully reviewed to
              create a list of <b>Top Options</b>.
            </CardText>
            <CardActions>
              <FlatButton
                primary
                label="Review Options"
                containerElement={
                  <Link to={`/resultsReview/${props.responseID}/${props.section}/0`} />
                }
              />
            </CardActions>
          </Card>
        ) : (
          <CaveatVisualization
            displayCriteria={props.section !== "controlRules"}
            colorCodedCriteria={props.section === "assessment"}
            {...props}
          />
        )}
        <Divider />
        <FlaggedQuestionList
          answerTextLookup={props.answerTextLookup}
          readOnly={props.readOnly}
          responseID={props.responseID}
          onItemClick={props.onQuestionClick}
          questions={props.flaggedQuestions}
          section={props.section}
          translation={props.translation}
        />
        <Divider />
        <InfluentialAnswersList
          section={props.section}
          readOnly={props.readOnly}
          responseID={props.responseID}
          onItemClick={props.onQuestionClick}
          answers={props.influentialAnswers}
          answerTextLookup={props.answerTextLookup}
          options={props.options}
          translation={props.translation}
        />
      </div>
    );
  }
}

//TODO: use one label mapping
const tabLabels = {
  monitoring: "Data Collection",
  assessment: "Assessment",
  controlRules: "Management Measures",
  enforcement: "Enforcement"
};

class Results extends React.Component {
  constructor(props) {
    super(props);
    this.onQuestionClick = this.onQuestionClick.bind(this);
    this.state = {
      answerEditorOpen: false,
      question: null,
      answer: null,
      showModal: false,
      filtersOpen: false
    };
  }

  componentDidMount() {
    if(this.props.response.userEdits.trIDForResponse && this.props.response.userEdits.trIDForResponse !== -1 && !this.props.translation){
      this.props.fetchTranslation(this.props.response.userEdits.trIDForResponse)
    }
  }

  render() {
    let props = this.props;
    let {
      readOnly,
      tabs,
      handleFisheryMetadataSave
    } = props;
    let activeTabStyle = { backgroundColor: "#4f6473" };
    let tabStyle = { backgroundColor: "#9ba7af" };
    let userEdits = props.response.userEdits ? props.response.userEdits : {};
    let headerLabel = (props.section === "enforcement") ? "Enforcement Results" : "Results";
    if(readOnly) { headerLabel = headerLabel + " - View Only"; }

    return (
      <div>
        <Card style={{ maxWidth: 1280, margin: "0 auto" }}>
        <BackgroundSyncStatusBar hidden={true} />
          <CardHeader title={headerLabel} titleStyle={{fontSize:"24px"}}/>
          <CardText>
            {/*props.section === "enforcement" ? <div>****EXTRA ENFORCEMENT DETAILS?*****<br/></div>: null*/}

            To understand the results section, see the <a href="https://fishpath.github.io/FishPath-Tool-User-Guide/fishpath-tool-interactive-results-page.html" target="_blank" rel="noopener noreferrer">User Guide Results Section</a>.
            Click <b>"Narrow Your Results"</b> to follow a 3-step process to review,
            understand, and create a narrowed list of appropriate options.
          </CardText>
        </Card>
        <Card style={{ maxWidth: 1280, margin: "0 auto" }}>
          <Tabs
            inkBarStyle={{ backgroundColor: "rgb(83, 219, 237)" }}
            value={props.section}
            onChange={this.tabChange.bind(this)}
          >
            {tabs.map(({ name, results }) => (
              <Tab
                key={name}
                style={props.section === name ? activeTabStyle : tabStyle}
                label={tabLabels[name]}
                value={name}
              >
                {!results.complete ? (
                  <IncompleteSection
                    responseID={props.responseID}
                    section={name}
                    readOnly={props.readOnly}
                    completed={results.completedQuestions}
                    incomplete={results.incompleteQuestions}
                    title={tabLabels[name]}
                    nextQuestion={results.nextQuestion}
                  />
                ) : (
                  <SectionResults
                    onOpenFiltersClick={this.handleOpenFiltersClick}
                    onGenerateReportClick={this.handleGenerateReportClick}
                    toggleHiddenOptions={props.toggleHiddenOptions}
                    onQuestionClick={this.onQuestionClick}
                    section={name}
                    answerTextLookup={this.props.answerTextLookup}
                    questionLookup={this.props.questionLookup}
                    {...results}
                    readOnly={props.readOnly}
                    responseID={props.responseID}
                    response={props.response}
                    userEdits={userEdits}
                    fishery={makeTitle(props.response)}
                    filterOptions={props.filterOptions[name]}
                    categories={props.categories}
                    toggleShortList={props.toggleShortList}
                    reviewStage={
                      props.response &&
                      props.response.userEdits &&
                      props.response.userEdits[props.section]
                        ? props.response.userEdits[props.section].reviewStage ||
                          0
                        : 0
                    }
                    topOptionsOnly={props.filterOptions[name].shortList}
                    starred={
                      props.response &&
                      props.response.userEdits &&
                      props.response.userEdits[props.section]
                        ? props.response.userEdits[props.section].starred || []
                        : []
                    }
                    translation={props.translation}
                  />
                )}
              </Tab>
            ))}
          </Tabs>
        </Card>
        <AnswerEditModal
          response={this.props.response}
          readOnly={readOnly}
          open={this.state.answerEditorOpen}
          question={this.state.question}
          answer={this.state.answer}
          trQuestion={this.state.trQuestion}
          onRequestClose={this.onAnswerModalClose.bind(this)}
          onSave={this.onAnswerSave}
          onSaveNote={this.handleSaveAnswerNote}
          onToggleFlagged={this.onToggleFlagged}
          section={props.section}
        />
        <FiltersAndSortingOptions
          section={this.state.filtersOpen}
          open={!!this.state.filtersOpen}
          onRequestClose={this.handleRequestFiltersClose}
        />

        { !props.response.commonName && (
          <FisheryMetadataDialog open={true} metadata={props.response} hasOldAttrs={true} isNew={false} handleSave={handleFisheryMetadataSave} />
        )}
      </div>
    );
  }


  handleOpenFiltersClick = section => {
    this.setState({ filtersOpen: section });
  };

  handleRequestFiltersClose = () => this.setState({ filtersOpen: false });

  onAnswerSave = (questionID, value, section) => {
    this.props.saveAnswer(questionID, value, section, this.props.response);
  };

  onToggleFlagged = questionID => {
    this.props.toggleFlagged(questionID, this.props.response);
  };

  tabChange(value) {
    this.props.router.push(
      "/questionnaire/results/" + this.props.responseID + "/" + value
    );
  }

  onQuestionClick(id) {
    let question = this.props.questions.find(q => q.id === id);
    if (question) {
      let answer = this.props.answers[question.id];
      let trQuestion = this.props.translation ? this.props.translation.questions.find(trQ => trQ.engID === question.id) : null
      this.setState({
        answerEditorOpen: true,
        question: question,
        answer: answer,
        trQuestion: trQuestion
      });
    }
  }

  onAnswerModalClose() {
    this.setState({
      answerEditorOpen: false,
      answer: null
    });
  }

  handleSaveAnswerNote = (id, value, response) => {
    this.props.saveAnswerNote(id, value, response);
    this.setState({
      answer: {
        ...this.state.answer,
        note: value
      }
    });
  };
}

let mapStateToProps = (state, ownProps) => {
  var section = ownProps.params.section;
  let fetching = false;
  fetching = state.responses.fetching;
  let response = getResponse(state);
  let readOnly = response
    ? response.email != state.auth.email && !state.auth.isAdmin
    : true;
  const results = getResults(state);
  let sectionsToDisplay = section === 'enforcement' ? ['enforcement'] : ['monitoring', 'assessment', 'controlRules'];
  let trIDForResponse = response.userEdits ? response.userEdits.trIDForResponse : -1;
  let translation = (trIDForResponse !== -1) ? state.translations.find((t) => t.id === trIDForResponse) : null;
  return {
    ...results,
    tabs: Object.keys(results)
      .filter(k => sectionsToDisplay.indexOf(k) >= 0)
      .map(key => ({ name: key, results: results[key] })),
    responseID: response ? response.metadata.id : ownProps.params.id,
    section: section,
    questions: state.questions,
    categories: (sortedCategories(state.categories) || []).filter(
      c => c.type === "target" || c.type === "option"
    ),
    answers: response ? response.answers : {},
    answerTextLookup: answerTextLookup(state),
    questionLookup: questionLookup(state),
    fetchingResponse: fetching,
    readOnly: readOnly,
    response: response,
    filterOptions: state.filterOptions,
    options: state.options,
    translation: translation
  };
};

let mapDispatchToProps = (dispatch, ownProps) => {
  return {
    saveAnswer: (id, value, section, response) =>
      dispatch(saveAnswer(id, value, section, response)),
    saveAnswerNote: (id, value, response) =>
      dispatch(saveAnswerNote(id, value, response)),
    toggleFlagged: (id, response) =>
      dispatch(toggleQuestionFlagged(id, response)),
    toggleShortList: () => dispatch(toggleShortList(ownProps.params.section)),
    handleFisheryMetadataSave: (attrs) => dispatch(updateFisheryMetadata(attrs, ownProps.params.id)),
    toggleHiddenOptions: () => dispatch(toggleHiddenOptions(ownProps.params.section)),
    fetchTranslation: (id) => dispatch(fetchTranslation(id))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Results));
